<script lang="ts">
  import type { Content } from "../../loader";
  let options: Content["options"] = {};

  export let title: string = "Section Header";
  export let content: Content | Promise<Content> = undefined;
  if (content)
    Promise.resolve(content).then((content) => (options = content.options));
</script>

<section class="content-section">
  <span class="content-heading">
    {#if content}
      {#await content}
        <span class="placeholder-text-short" />
      {:then { title }}
        {#each title.split(" ") as word}
          <span>{word}</span>
        {/each}
      {/await}
    {:else}
      {#each title.split(" ") as word}
        <span>{word}</span>
      {/each}
    {/if}
  </span>
  <div
    class="content-box"
    style={`
    ${options.justify ? "text-align: justify;" : ""} 
    ${options.preserveWhitespace ? "white-space: pre;" : ""}`}
  >
    {#if content}
      {#await content}
        <div class="spinner" />
      {:then { html: htmlContent }}
        {@html htmlContent}
      {/await}
    {:else}
      <slot />
    {/if}
  </div>
</section>

<style lang="scss">
  .content-section {
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    margin-bottom: 1rem;

    & > .content-heading {
      display: inline-block;
      padding-left: 0.5rem;
      padding-bottom: 0.3rem;
      text-transform: uppercase;
      font-weight: bold;
      & > span {
        &:nth-child(odd) {
          color: whitesmoke;
        }
        &:nth-child(even) {
          color: rgba(255, 165, 0, 1);
        }
      }
    }

    & > .content-box {
      border-radius: 4px;
      border-color: #ccc;
      border-width: 1px;
      border-style: solid;
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 10px;
      padding-bottom: 10px;

      background: rgb(11, 15, 24);
      background: linear-gradient(
        90deg,
        rgba(11, 15, 24, 1) 0%,
        rgba(25, 31, 43, 1) 50%,
        rgba(11, 15, 24, 1) 100%
      );
      color: #ccc;

      & :global(h3) {
        font-weight: bold;
        font-size: 1.2em;
        color: #8995ae;
      }

      & :global(hr) {
        border: 0;
        height: 1px;
        background-color: #8995ae;
      }

      & :global(a) {
        text-decoration: none;
        color: rgba(255, 165, 0, 1);

        &:hover {
          color: #ffff00;
        }
      }

      & :global(img) {
        max-width: 100%;
      }
    }
  }
</style>
